import './replace_asset_modal_ui.less';
import React from 'react';

import { makeRandomAlphaNumeric } from 'zoomforth_zfutils/random.js';
import Button from 'zoomforth_codesbane_editor/component_lib/button.jsx';
import SiteList from './site_list';
import { CloseIcon, CheckCircleIcon } from 'zoomforth_component_lib/app_modern_icons';

const SiteListModalUi = (props) => {
  const {
    siteList,
    onClose
  } = props;

  return (
    <div id={`replace-asset-modal-${makeRandomAlphaNumeric(5)}`}>
      <span className="close-button" onClick={onClose}><CloseIcon /></span>
      <div className="header">
        <h2>Asset in use on {siteList.length} sites</h2>
        <p>Click on each site title to check setting individually.</p>
      </div>
      <div className="body">
        <SiteList sites={siteList} />
      </div>
      <div className="actions">
        <div className="action-button">
          <Button className="done-button" onClick={onClose}>
            <CheckCircleIcon />
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SiteListModalUi;